module.exports = __webpack_public_path__ + "static/media/centro_abajo_1.193d25a0.mp4";